import {
	PORTFOLIO_SORT,
	type PortfolioSortKey,
} from "web_myplann/Portfolio/Components/Redesign/Filter/portfolioSortKey";
import {
	PORTFOLIO_CATEGORY_ORDER,
	type PortfolioCategoryId,
} from "web_myplann/Portfolio/Types/portfolioCategory";
import { z } from "zod";

export const getFilterFormSchema = () =>
	z.object({
		categories: z.array(
			z.enum(
				PORTFOLIO_CATEGORY_ORDER as [
					PortfolioCategoryId,
					...PortfolioCategoryId[],
				],
			),
		),
		sort: z.enum([
			PORTFOLIO_SORT.oblast,
			PORTFOLIO_SORT.name,
			PORTFOLIO_SORT.producer,
			PORTFOLIO_SORT.value,
		]),
		sortDesc: z.boolean(),
	});

export type FilterFormValues = {
	categories: PortfolioCategoryId[];
	sort: PortfolioSortKey;
	sortDesc: boolean;
};
